module.exports = __webpack_public_path__ + "img/40.209ccce5.png";